import {Role} from "~/modules/users/lib/roles-utils";
import {Vue} from "vue-property-decorator";
import {getClientRolesConfig} from "~/modules/client/service";
import {Recipients} from "~/modules/notifications/lib/recipients";
import {sort} from "~/lib/helpers";
import {uniqBy} from "lodash";

export class AvailableRolesCollection {

  public rolesByClients: Record<string, Role[]> = {};

  async load(clientUUID: string) {
    if (!this.rolesByClients.hasOwnProperty(clientUUID)) {
      Vue.set(this.rolesByClients, clientUUID, (await getClientRolesConfig(clientUUID)).map(config => config.role));
    }
  }

  getRolesOfClient(clientUUID) {
    return this.rolesByClients[clientUUID];
  }

  // outputs only available roles for the currently selected clients
  get(recipients: Recipients) {
    return sort(uniqBy(Object.keys(this.rolesByClients).reduce((output, clientUUID) => {

      if (recipients.isClientSelected(clientUUID)) {
        output = [...output, ...this.rolesByClients[clientUUID]];
      }

      return output;
    }, []), role => role.uuid), byLabel);
  }

}

function byLabel(a: Role, b: Role) {
  if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
  if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
  return 0;
}